<script>
    import { preventDefault } from 'svelte/legacy';

    import { createEventDispatcher } from 'svelte';
    import tagService from '../service.js';
    import { flatten422Errors} from '../../../services/api.svelte.js';
    import { translateErrorMessages } from '../../../services/api.svelte.js';
    import SearchResults from '../../../components/search-results.svelte';
    import vulnerabilityService from '../../vulnerability/service.js';
    import customService from '../../vulnerability/custom/v2-service.js';
    import { format, locale } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    let { tag, parent, vulnerabilities = [] } = $props();

    let formData = $state({});
    let formDataPromise;
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    let tagRegexError = null;
    // API 422 errors
    let formApiErrors = {};
    let vulnerabilities_are_loading = $state(false);
    let search_results = $state();
    let search_result = $state("");
    let showDropdown = $state(false);
    let has_searched_once = false;
    let vulnerabilitiesToAssociate = $state([]);
    let vulnerabilitiesToRemove    = [];
    let vulnerabilitiesAssociated  = $state([]);
    let is_edit;

    // add form
    if (!tag) {
        formDataPromise = Promise.resolve({});
        is_edit = false;
    }
    // edit form
    else {
        formData = {
            name: tag.name,
        };
        is_edit = true;
        if(!tag.vulnerabilities && tag.vulnerability){
            vulnerabilitiesAssociated = typeof tag.vulnerability === 'string' ? JSON.parse(tag.vulnerability) : tag.vulnerability;
        }
        else if(tag.vulnerabilities && !tag.vulnerability) {
            vulnerabilitiesAssociated = JSON.parse(tag.vulnerabilities);
        }
        else {
            vulnerabilitiesAssociated = [];
        }
    }

    const getVulnerabilities = async () =>{
        vulnerabilities_are_loading = true;
        let customVuls = await customService.search('v2/vulnerability/custom', {});
        vulnerabilities = await vulnerabilityService.search('v2/vulnerability/', {});
        vulnerabilities = [...vulnerabilities, ...customVuls];
        vulnerabilities_are_loading = false;
        showDropdown = true;
        return vulnerabilities;
    }

    function containsUppercase(str) {
        return /[A-Z]/.test(str);
    }

    function handleSubmit() {
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if(containsUppercase(formData.name)) return tagRegexError = 'Se han utilizado caracteres inválidos. Por favor, cargue las etiquetas utilizando solamente números, letras minúsculas o guiones medios (-)';

        tagService.save(formData, [])
            .then(async savedTag => {
                if(vulnerabilitiesToAssociate.length > 0){
                    for(let vulnerability of vulnerabilitiesToAssociate){
                        let reqData = {
                            tag_id: savedTag.id,
                            target_object_type: "Vulnerability",
                            target_object_id: vulnerability.id
                        }
                        await tagService.saveAssociation(reqData, [], {});
                    }
                }

                dispatch("save", {savedTag});
                //clear formData and form status and errors
                // when modal is closed after sending add request
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {}
                return true;
            })
            .catch(errors => {
                if(typeof(errors.detail) == 'string'){
                   APIerror = translateErrorMessages(errors.detail, "Etiquetas");
                }
                else {
                    // parse API errors
                    formApiErrors = flatten422Errors(errors);
                }

                return false;
            })
        ;
    }

    const handleSearch = (e) =>{
        showDropdown = true;
        search_results = vulnerabilities;
        let searchValue = e.target.value;
        search_results = search_results.filter(sr=> {
            if(!sr.title) sr.title = "";
            if(!sr.title_es) sr.title_es = sr.title;
            return sr.title_es.includes(searchValue);
        });
        search_results = search_results;
    }

    const containsObject = (obj, list) => {
        var i;
        for (i = 0; i < list.length; i++) {
            if (list[i].id === obj.id) {
                return true;
            }
        }
        return false;
    }

    const selectVulnerability = (e) =>{
        let vulnerability = e.detail;
        formData.vulnerability_id = vulnerability.id;
        //showDropdown = false;
        search_result = vulnerability.title_es || vulnerability.title;

        if(!containsObject(vulnerability, vulnerabilitiesToAssociate)){
            vulnerabilitiesToAssociate.push(vulnerability);
        }
        vulnerabilitiesToAssociate = vulnerabilitiesToAssociate;
        //vulnerabilities = vulnerabilities.filter(item=> item.id != vulnerability.id);
        //@TODO: remove/mark selected vulnerabilities on search panel
    }

    const removeVulnerabilityToAssociate = (i, )=>{
        vulnerabilitiesToRemove.push(vulnerabilitiesToAssociate[i]);
        vulnerabilitiesToAssociate.splice(i, 1);
        vulnerabilitiesToAssociate = vulnerabilitiesToAssociate;
    }

    const handleVulnerabilityInput = async () =>{
        vulnerabilities = await getVulnerabilities();
        for(let vul of vulnerabilities){
            if(!vul.title) vul.title = "";
            if(!vul.title_es) vul.title_es = vul.title;
            vul.name = vul.title_es;
        }
        if(tag && tag.vulnerabilities){
            if(typeof tag.vulnerabilities === "string") tag.vulnerabilities = JSON.parse(tag.vulnerabilities);
            if(tag.vulnerabilities.length > 0){
                for(let vul of tag.vulnerabilities){
                    if(!vul.title) vul.title = "";
                    if(!vul.title_es) vul.title_es = vul.title;
                    vul.name = vul.title_es;
                }
            }
        }
        else if(tag && tag.vulnerability){
            if(typeof tag.vulnerability === "string") tag.vulnerability = JSON.parse(tag.vulnerability);
            if(tag.vulnerability.length > 0 && tag.vulnerability[0]){
                for(let vul of tag.vulnerability){
                    if(!vul.title) vul.title = vul.id;
                    if(!vul.title_es) vul.title_es = vul.title;
                    vul.name = $locale == "es" ? vul.title_es : vul.title;
                }
            }
        }
        //vulnerabilities = vulnerabilities;
        search_results = vulnerabilities;
        has_searched_once = true;
    }

    handleVulnerabilityInput();
</script>
<style>
    .btnDeleteVulnerability{
        cursor: pointer;
    }
</style>

<form role="form" novalidate onsubmit={preventDefault(handleSubmit)}>
    <div class="card">
        <div class="card-body" style="position: relative;">
            {#if tag}
                <div class="mb-3">
                    <label for="name">{$format("form.fields.name")}<span  class="text-danger">*</span></label>
                    <span class="d-block">{tag.name}</span>
                </div>
            {/if}
            <div class="mb-3">
                <div>
                    <span>{$format("page.tag.search_vul")}</span>
                    <span style="position: relative;">
                        {#if vulnerabilities_are_loading}
                            <i class="fa fa-spin fa-sync-alt"></i>
                        {:else}
                            <input class="form-control" type="text" oninput={handleSearch} placeholder="Buscar..." bind:value={search_result} style="text-indent: 20px;"/>
                            {#if !showDropdown}<span onclick={handleVulnerabilityInput} style="font-size: 10px; text-decoration: underline; cursor: pointer;">Ver todas las vulnerabilidades</span>{/if}
                            <i class="fas fa-search" style="position: absolute; left: 5px; top: 2px; color: #0000003d;"></i>
                        {/if}
                    </span>
                    <SearchResults elements={search_results} {showDropdown} element_being_selected={"vulnerabilidad"} on:selectElement={selectVulnerability} on:closeSearchPanel={()=>showDropdown = false} />
                </div>
                <select id="tagFormVulnerability" class="form-control d-none" bind:value={formData.vulnerability_id} style="max-width: 318px; margin-top: 1em;">
                    <option value="none">{$format("form.fields.select")}...</option>
                    {#if !vulnerabilities_are_loading}
                        {#each vulnerabilities as vulnerability}
                            {#if $locale == 'es'}
                                <option value={vulnerability.id}>{vulnerability.title_es || vulnerability.title || ""}</option>
                            {:else}
                                <option value={vulnerability.id}>{vulnerability.title || vulnerability.title_es || ""}</option>
                            {/if}
                        {/each}
                    {/if}
                </select>
            </div>
            {#if !parent || parent != 'detail'}
                <label for="associatedVulnerabilities">{$format("page.tag.associated_vulnerabilities")}:</label>
                {#if vulnerabilitiesAssociated.length > 0 && vulnerabilitiesAssociated[0]}
                    {#each vulnerabilitiesAssociated as vulnerability, i}
                        <div>{vulnerability.title_es || vulnerability.title || ""}</div>
                    {/each}
                {:else}
                    <div>{$format("results_not_found")}</div>
                {/if}
            {/if}
            {#if vulnerabilitiesToAssociate.length > 0}
                <label for="vulnerabilitiesToAssociate" class="mt-3">{$format("page.tag.vuls_to_associate")}:</label>
                {#each vulnerabilitiesToAssociate as vulnerability, i}
                    <div>{vulnerability.title_es || vulnerability.title || ""}<i class="fas fa-times btnDeleteVulnerability float-end" onclick={()=>removeVulnerabilityToAssociate(i, vulnerabilitiesToAssociate)}></i></div>
                {/each}
            {/if}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn">{$format("buttons.save")}</button>
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
        </div>

    </div>
</form>
